import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'; 
import { Globals } from '../objects/Globals';
import { forkJoin, Subject } from 'rxjs';
import { EnvService } from '../env.service';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService {
  private defaultId = '00000000-0000-0000-0000-000000000000';
  private serviceUrl:string;
  parentId: string = "";
  currentParentId: Subject<any> = new Subject<any>();
  currentParentIdChanged$ = this.currentParentId.asObservable();

  // documentClick: Subject<any> = new Subject<any>();
  // documentClickChanged$ = this.documentClick.asObservable();

  constructor(private http:HttpClient, private globals:Globals, private env: EnvService) { this.serviceUrl = this.env.servicePath; }

  setParentId(id:any){
    // if (this.parentId != id){ //avoid registering duplicate id
      this.parentId = id;
      this.currentParentId.next(id);
    // }
  }

  // setDocumentClick(event:any){
  //   this.documentClick.next(event);
  // }

  getEPICPage(pageName:string, isMobile: boolean){
    var path = this.serviceUrl +"GetEPICPage/"+pageName + "?isMobile=" + isMobile;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getEPICGroup(pageId:string, groupId:string){
    var path = this.serviceUrl +"GetEPICGroup/"+pageId+"/"+groupId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getEPICGroupAll(pageId:string, groupIds:string[]){
    let getObs = [];
    for (let groupId of groupIds) {
      var path = this.serviceUrl +"GetEPICGroup/"+pageId+"/"+groupId;
      var httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
      };
      getObs.push(this.http.get<Blob>(`${path}`, httpOptions));
    }
    return forkJoin(getObs);
  }

  getRelatedEPICs(conversationId:string, messageId:string, groupId:string, groupOrder:string) {
    var path = this.serviceUrl +"GetRelatedEPICs/"+conversationId+"/"+messageId+"/"+groupId+"/"+groupOrder;;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  searchEPICs(searchTerm:string){
    var path = this.serviceUrl +"SearchEpicByTag/"+searchTerm;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getSearchResult(id:string){
    var path = this.serviceUrl +"GetSearchResult/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getEPICContent(groupId:string,contentId:string, body: any){
    var path = this.serviceUrl +"GetEPICContent/"+groupId+"/"+contentId;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, body, httpOptions);
  }

  getParentEPICId(id:string){
    var path = this.serviceUrl +"GetParentEPICId/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getAllParentsEPICId(id:string){
    var path = this.serviceUrl +"GetAllParentsEPICId/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getAppVersion(){
    var path = this.serviceUrl +"GetAppVersion";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId , "Session": this.defaultId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getNotificationPrompt(){
    var path = this.serviceUrl +"GetNotificationPrompt";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.defaultId , "Session": this.defaultId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getKpiCard(id : string){
    var path = this.serviceUrl +"GetKpiCard/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId , "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getWebContentCard(id : string){
    var path = this.serviceUrl +"GetWebContentCard/" + id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId , "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  getFAQ(){
    var path = this.serviceUrl +"GetFAQ";
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId , "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.get<string>(`${path}`, httpOptions);
  }

  closeCard(id: string){
    var path = this.serviceUrl +"CloseCard/"+id;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, "", httpOptions);
  }

  executeGenericWorkflow(actionName: string, param: any){
    var path = this.serviceUrl +"ExecuteGenericWorkflow/"+actionName;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, param, httpOptions);
  }

  convertToDecimal(value: string, formatString: string){
    var path = this.serviceUrl +"ConvertToDecimal/" + value;
    var httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': 'true', "User": this.globals.Session.Session.UserId, "Session": this.globals.Session.Session.SessionId })
    };
    return this.http.post<string>(`${path}`, formatString, httpOptions);
  }

}
